__turbopack_context__.v({
  "inputs": "_3ZT8qa_inputs",
  "label": "_3ZT8qa_label",
  "rangeInput": "_3ZT8qa_rangeInput",
  "root": "_3ZT8qa_root",
  "track": "_3ZT8qa_track",
  "trackBase": "_3ZT8qa_trackBase",
  "trackHighlight": "_3ZT8qa_trackHighlight",
  "values": "_3ZT8qa_values",
});
